export default __webpack_public_path__ + "static/media/bingo.8053e6f7.png";